<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="文章详情"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="5">小程序链接：</el-col>
        <el-col :span="19"><span ref='path'>media/article/article?articleId={{ showForm.articleId }}</span> <el-button type="primary" class="ml-10" @click="copy" size="mini" plain>复制</el-button></el-col>
      </el-row>
      <el-row>
        <el-col :span="5">文章标题：</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">文章详情：</el-col>
        <el-col :span="15">
          <div
            class="rich-box"
            v-html="showForm.basic && showForm.basic.text"
          ></div>
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { findArticle } from '@/api/display'
export default {
  name: 'ArticleDetail',
  emits: ['fetch-data'],
  data() {
    return {
      showForm: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const articleId = row.articleId
      const data = await findArticle({
        articleId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    copy() {
      const text = this.$refs.path.innerText
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制成功')
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
    overflow: auto;
    max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
